import React, {useEffect, useState} from "react";
import classNames from "classnames";
import "./index.scss";

import SettingImageEdit from "../SettingImageEdit";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const SectionItemSettingImageEdit = ({ column, item, value, onPropChange }) => {
    const [accessor, setAccessor] = useState(column.accessor);
    const [settingsAccessor, setSettingsAccessor] = useState(column.settingsAaccessor);
    const [tabIndex, setTabIndex] = useState(0);

    useEffect(() => {
        if(column.tabs && column.tabs.length) {
            const firstTab = column.tabs[0];

            setAccessor(() => firstTab.accessor);
            setSettingsAccessor(() => firstTab.settingsAaccessor);
        }
    }, [column.tabs]);

    const handleOnChange = (image) => {
        if(column.isReadonly){
            return;
        }

        onPropChange({ [accessor]: image });
    }

    const handleOnSettingsChange = (settings) => {
        if(column.isReadonly){
            return;
        }

        onPropChange({ [settingsAccessor]: settings })
    }

    const handleOnChangeTab = tab => {
        setTabIndex(tab);
        const image = column.tabs[tab];
        if(image) {
            setAccessor(image.accessor);
            setSettingsAccessor(image.settingsAaccessor);
        }
    }


    return (
        <div key={`propItem-${accessor}`} className={classNames("sectionItemSettingImageEdit", {withTabs: !!column.tabs})}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            {column.tabs && column.tabs.length && (
                <div className={"imageTabs"}>
                    {column.tabs.map(({ title }, i) => (
                        <div
                            key={`imageTab-${i}`}
                            className={classNames("tab", { active: i === tabIndex})}
                            onClick={() => handleOnChangeTab(i)}
                        >
                            {getTranslateTitle(title)}
                        </div>
                    ))}
                </div>
            )}
            <SettingImageEdit value={item[accessor]} settings={item[settingsAccessor]}
                onChange={image=> handleOnChange(image)}
                disabled={column.isReadonly}
                onSettingsChange={settings=> handleOnSettingsChange(settings)}
            />
        </div>
    );
}

export default SectionItemSettingImageEdit;
